var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.canEdit
    ? _c(
        "div",
        {
          staticClass: "cw-container-actions",
        },
        [
          _c("studip-action-menu", {
            attrs: {
              items: _vm.menuItems,
              context: _vm.container.attributes.title,
              collapseAt: 1,
            },
            on: {
              editContainer: _vm.editContainer,
              changeContainer: _vm.changeContainer,
              deleteContainer: _vm.deleteContainer,
              removeLock: _vm.removeLock,
              copyToClipboard: _vm.copyToClipboard,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }